<template>
  <div class="material-Input-Price-View">
    <PageTitle imagem="bottles.png" main="Orçamento de Insumos" sub="" />
    <MaterialInputPriceView />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import MaterialInputPriceView from "./materialInputPriceViewTable";

export default {
  name: "materialInputPriceView",
  components: { PageTitle, MaterialInputPriceView },
  beforeDestroy() {

  }
};
</script>



<style></style>